import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion';
import { Reveal } from '@/components/system';

const faqItems = [
  {
    id: 'o-que-e',
    question: 'O que é a Kuiva?',
    answer:
      'A Kuiva é uma plataforma angolana que liga quem procura apoio em saúde mental a psicólogos qualificados. Podes explorar perfis, ver preços em kwanza e marcar consultas de forma simples, com contacto direto por WhatsApp quando fizer sentido para ti.',
  },
  {
    id: 'como-marcar',
    question: 'Como marco uma consulta?',
    answer:
      'Cria uma conta ou entra na secção «Explorar», escolhe um profissional que se adeque às tuas necessidades, vê disponibilidade e segue os passos para escolher data e hora. Depois confirmas os dados e podes contactar o profissional pelo WhatsApp para combinar o último pormenor, se precisares.',
  },
  {
    id: 'precos',
    question: 'Quanto custa uma sessão?',
    answer:
      'Os valores são definidos por cada profissional e aparecem claramente no perfil, em kwanza. Na Kuiva indicamos valores a partir de referências comuns (por exemplo, desde 8.000 Kz), mas o preço final é o que estiver publicado no perfil do psicólogo que escolheres.',
  },
  {
    id: 'pagamento',
    question: 'Como funciona o pagamento?',
    answer:
      'O pagamento é acordado diretamente com o profissional (por exemplo, por transferência, multicaixa ou outro meio que ambos definam). A Kuiva não intermedia pagamentos: o nosso papel é facilitar o encontro entre ti e o psicólogo.',
  },
  {
    id: 'confidencialidade',
    question: 'Os meus dados e conversas são confidenciais?',
    answer:
      'Sim. Tratamos a tua privacidade com seriedade. O que partilhas na plataforma e com os profissionais deve seguir as regras de ética e sigilo da psicologia. Recomendamos que leias também a política de privacidade da Kuiva quando estiver disponível na íntegra.',
  },
  {
    id: 'profissionais',
    question: 'Os psicólogos na Kuiva são verificados?',
    answer:
      'A nossa equipa trabalha para validar identidade e formação dos profissionais que aparecem como verificados. Procuramos garantir que quem está na plataforma está habilitado a prestar apoio psicológico, sem substituir regras oficiais das ordens profissionais quando existirem.',
  },
  {
    id: 'gratuito',
    question: 'Usar a Kuiva tem custo?',
    answer:
      'Navegar, ver perfis e informações na plataforma é gratuito. Pagas apenas pelas sessões (ou pacotes) que acordares com o teu psicólogo, segundo o preço indicado no perfil dele ou dela.',
  },
  {
    id: 'nao-psicologo',
    question: 'Sou psicólogo. Como posso integrar a Kuiva?',
    answer:
      'Podes candidatar-te através do botão «Sou profissional» na página inicial. Vais preencher um formulário com dados profissionais, formação e especialidades. A equipa analisa a candidatura e entra em contacto contigo para os passos seguintes.',
  },
];

export function FAQSection() {
  return (
    <section
      id="perguntas-frequentes"
      className="section-y scroll-mt-20 border-t border-border/60 bg-kuiva-pattern px-3 section-glass sm:px-6"
      aria-labelledby="faq-heading"
    >
      <div className="mx-auto w-full min-w-0 max-w-4xl">
        <Reveal>
          <div className="mb-6 text-center sm:mb-7">
            <span className="glass-surface mb-3 inline-block rounded-full px-3 py-1 text-xs font-medium text-kuiva-blue sm:px-4 sm:py-1.5 sm:text-sm">
              Ajuda
            </span>
            <h2
              id="faq-heading"
              className="mb-2 px-1 text-2xl font-bold text-foreground sm:text-3xl"
            >
              Perguntas frequentes
            </h2>
            <p className="mx-auto max-w-xl text-sm text-muted-foreground sm:text-base">
              Respostas rápidas às dúvidas mais comuns — sem precisares de sair da página.
            </p>
          </div>
        </Reveal>

        <Reveal delayMs={140}>
          <Accordion
            type="single"
            collapsible
            className="glass-surface w-full rounded-2xl border border-white/60 px-3 shadow-kuiva sm:px-5"
          >
            {faqItems.map((item) => (
              <AccordionItem key={item.id} value={item.id} className="border-border">
                <AccordionTrigger className="py-3 text-left text-sm font-semibold text-foreground hover:no-underline sm:py-3.5 sm:text-base">
                  {item.question}
                </AccordionTrigger>
                <AccordionContent className="text-sm leading-relaxed text-muted-foreground sm:text-base">
                  {item.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
}
